import React from 'react'
import styled from 'styled-components'

export default ({ fg, mcss }) => {
  return (
    <Wrap fg={fg} mcss={mcss}>
      <svg
        width="26"
        height="25"
        viewBox="0 0 26 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0"
          mask-type="alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="26"
          height="25"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 25H25.003V0H0V25Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.5015 0C9.10629 0 8.68056 0.0143912 7.34714 0.0752311C6.0165 0.135922 5.10773 0.347274 4.31254 0.656337C3.49046 0.975771 2.79328 1.40324 2.09823 2.09823C1.40324 2.79328 0.975771 3.49046 0.656337 4.31254C0.347274 5.10773 0.135922 6.0165 0.0752311 7.34714C0.0143912 8.68056 0 9.10629 0 12.5015C0 15.8967 0.0143912 16.3224 0.0752311 17.6558C0.135922 18.9865 0.347274 19.8953 0.656337 20.6904C0.975771 21.5125 1.40324 22.2097 2.09823 22.9047C2.79328 23.5997 3.49046 24.0272 4.31254 24.3467C5.10773 24.6557 6.0165 24.8671 7.34714 24.9277C8.68056 24.9886 9.10629 25.003 12.5015 25.003C15.8967 25.003 16.3224 24.9886 17.6558 24.9277C18.9865 24.8671 19.8953 24.6557 20.6904 24.3467C21.5125 24.0272 22.2097 23.5997 22.9047 22.9047C23.5997 22.2097 24.0272 21.5125 24.3467 20.6904C24.6557 19.8953 24.8671 18.9865 24.9277 17.6558C24.9886 16.3224 25.003 15.8967 25.003 12.5015C25.003 9.10629 24.9886 8.68056 24.9277 7.34714C24.8671 6.0165 24.6557 5.10773 24.3467 4.31254C24.0272 3.49046 23.5997 2.79328 22.9047 2.09823C22.2097 1.40324 21.5125 0.975771 20.6904 0.656337C19.8953 0.347274 18.9865 0.135922 17.6558 0.0752311C16.3224 0.0143912 15.8967 0 12.5015 0ZM12.5022 2.25258C15.8402 2.25258 16.2356 2.26533 17.5538 2.32548C18.7727 2.38106 19.4347 2.58472 19.8752 2.75592C20.4587 2.98271 20.8752 3.25361 21.3126 3.6911C21.7501 4.12854 22.021 4.54499 22.2478 5.12853C22.419 5.56905 22.6227 6.23099 22.6782 7.44988C22.7384 8.76811 22.7511 9.16352 22.7511 12.5016C22.7511 15.8396 22.7384 16.235 22.6782 17.5532C22.6227 18.7721 22.419 19.4341 22.2478 19.8746C22.021 20.4581 21.7501 20.8746 21.3126 21.312C20.8752 21.7495 20.4587 22.0204 19.8752 22.2472C19.4347 22.4184 18.7727 22.622 17.5538 22.6776C16.2358 22.7378 15.8404 22.7505 12.5022 22.7505C9.16388 22.7505 8.76857 22.7378 7.45048 22.6776C6.2316 22.622 5.56966 22.4184 5.12914 22.2472C4.5456 22.0204 4.12915 21.7495 3.69171 21.312C3.25427 20.8746 2.98331 20.4581 2.75653 19.8746C2.58532 19.4341 2.38166 18.7721 2.32608 17.5532C2.26594 16.235 2.25319 15.8396 2.25319 12.5016C2.25319 9.16352 2.26594 8.76811 2.32608 7.44988C2.38166 6.23099 2.58532 5.56905 2.75653 5.12853C2.98331 4.54499 3.25422 4.12854 3.69171 3.6911C4.12915 3.25361 4.5456 2.98271 5.12914 2.75592C5.56966 2.58472 6.2316 2.38106 7.45048 2.32548C8.76872 2.26533 9.16413 2.25258 12.5022 2.25258V2.25258Z"
            fill="#454545"
          />
        </g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.5044 16.6686C10.2029 16.6686 8.33725 14.8029 8.33725 12.5014C8.33725 10.1999 10.2029 8.33424 12.5044 8.33424C14.8059 8.33424 16.6716 10.1999 16.6716 12.5014C16.6716 14.8029 14.8059 16.6686 12.5044 16.6686ZM12.5037 6.08154C8.95815 6.08154 6.08398 8.95571 6.08398 12.5012C6.08398 16.0467 8.95815 18.9209 12.5037 18.9209C16.0492 18.9209 18.9233 16.0467 18.9233 12.5012C18.9233 8.95571 16.0492 6.08154 12.5037 6.08154V6.08154Z"
          fill="#454545"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.6781 5.82809C20.6781 6.65662 20.0064 7.32824 19.1779 7.32824C18.3494 7.32824 17.6777 6.65662 17.6777 5.82809C17.6777 4.99955 18.3494 4.32788 19.1779 4.32788C20.0064 4.32788 20.6781 4.99955 20.6781 5.82809"
          fill="#454545"
        />
      </svg>
    </Wrap>
  )
}

const Wrap = styled.div`
  svg path {
    fill: ${props => (props.fg ? props.fg : props.theme.pageTheme.fgSecondary)};
  }

  ${({ mcss }) => mcss};
`
